
<lib-filter-list [configService]="config"></lib-filter-list>